/**
 * @class
 */
T.FooterRegister = Class({
		/**
		 * @lends {Layout#}
		 */
		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'register',
				els: [
					this._bgNode = mkE({
						tag: 'div',
						className: 'background',
						els: [
							{
								tag: 'div',
								className: 'container',
								els: [
									{
										tag: 'div',
										className: 'va'
									},
									{
										tag: 'div',
										className: 'wrapper',
										els: [
											{
												tag: 'h1',
												className: 'title',
												text: D.Lang.get('home.register.title')
											},
											{
												tag: 'a',
												href: D.url(D.Lang.get('home.register.button.link')),
												className: 'button button-large button-pink',
												text: D.Lang.get('home.register.button')
											}
										]
									}
								]
							}
						]
					})
				]
			});

			this._onTime(true);
		},

		_index: -1,
		_MAX: 4,
		_TIMEOUT: 5000,

		_onTime: function (init) {
			if( init !== true && !D.inScreen(this.node) ) {
				setTimeout(this._onTime, this._TIMEOUT);
				return;
			}
			if( this._index >= this._MAX ) {
				this._index = 0;
			} else {
				this._index++;
			}
			this._preload = new Image();
			this._preload.onload = this._onLoad;
			this._preload.src = `/assets/images/home/footer/${this._index}.jpg`;
			this._preload.srcset = `/assets/images/home/footer/${this._index}.jpg 1x, /assets/images/home/footer/${this._index}@2x.jpg 2x`;
		},

		_onLoad: function () {
			const src = this._preload.currentSrc || this._preload.src;
			this._bgNode.style.backgroundImage = `url(${src})`;
			setTimeout(this._onTime, this._TIMEOUT);
		}
	},
	mkE.Base
);